<template lang="pug">
div(
    v-once
    :class="styles.root"
    ref="qrCodeRef"
    id="generated-qr"
)
</template>

<script lang="ts">
import Vue, { onMounted, PropType, ref, toRefs, useCssModule } from 'vue'
import QRCodeStyling, {
    DrawType,
    ErrorCorrectionLevel,
    Mode,
    TypeNumber,
} from 'qr-code-styling'

export type QrProps = {
    text: string
    isLogo?: boolean
}

const options = {
    width: 1000,
    height: 1000,
    type: 'canvas' as DrawType,
    qrOptions: {
        typeNumber: 0 as TypeNumber,
        mode: 'Byte' as Mode,
        errorCorrectionLevel: 'Q' as ErrorCorrectionLevel,
    },
}

export default Vue.extend({
    name: 'Qr',
    props: {
        text: {
            type: String as PropType<QrProps['text']>,
            required: true,
        },
        isLogo: {
            type: Boolean as PropType<QrProps['isLogo']>,
        },
    },
    setup(props) {
        const styles = useCssModule()
        const { text, isLogo } = toRefs(props)

        const qrCodeRef = ref<HTMLDivElement>()

        const qrCode = new QRCodeStyling({
            ...options,
            data: text.value,
            ...(isLogo.value && {
                image: '/images/common/namba-logo-square.svg',
                imageOptions: {
                    hideBackgroundDots: true,
                    imageSize: 0.4,
                },
            }),
        })

        onMounted(() => qrCode.append(qrCodeRef.value))

        return {
            styles,
            qrCodeRef,
        }
    },
})
</script>

<style module lang="scss" src="./Qr.module.scss" />
